




















































import Vue from 'vue'
import Component from 'vue-class-component'
import { Mutation, State } from 'vuex-class'

  @Component
export default class Footer extends Vue {
    @State('cityText')
    cityText!: string

    @State('cityImage')
    cityImage!: string

    @Mutation('updateCenter')
    updateCenterMutation!: (center: Array<number>) => {}

    localize () {
      navigator.geolocation.getCurrentPosition((position) => {
        const lat = position.coords.latitude
        const long = position.coords.longitude
        this.updateCenterMutation(
          [lat, long]
        )
      }, positionError => {
        console.log(positionError)
      })
    }
}
